import { openModal } from '@core/components/ModalStack';
import { FormSharesModalProps } from './FormSharesModal';

export async function openFormShareModal(props: FormSharesModalProps) {
  const { FormSharesModal } = await import('./FormSharesModal');

  openModal(FormSharesModal, props);
}
